import React, {useState,useEffect,useMemo} from "react";
import "./Sortable.scss";
import { ReactSortable } from "react-sortablejs";
import memoize from "memoizee";

function Sortable({list,onChange,render,wrapper=null}) {
  const [state, setState] = useState([]);
  useEffect(()=>{
    setState(list.map((o)=>{return{...o}}));
  },[list]);
  const setList = (newList) => {
    setState(newList);
    let changed=false;
    const res=[];
    newList.forEach((item, i) => {
      if (item.sort!==i) {
        changed=true;
        res.push({...item,sort:i});
      } else {
        res.push(item);
      }
    });
    if (changed) {
      onChange(res);
    }
  };
  const memoized = useMemo(()=>memoize(render,
  	{
  		normalizer: function(args) {
  			// args is arguments object as accessible in memoized function
  			return JSON.stringify(args[0]);
  		}
  	}
  ),[render]);
  useEffect(()=>{
    console.log('render changed');
  },[render]);
  return <ReactSortable tag={wrapper} list={state} setList={setList} handle='.sort-handle'>
    {state.map((item) => memoized(item))}
  </ReactSortable>;
}

export default Sortable;
